<section class="fina-onboarding-navbar" [class.fina-onboarding-navbar--compact]="isCompact" *ngIf="phase && !isOnboardingComplete">
    <div class="fina-onboarding-navbar__header">
        <button type="button" class="fina-onboarding-navbar__progress-ring" (click)="openDetail()" [attr.aria-label]="'Ver detalle del onboarding, ' + completionPercent + '% completado'">
            <svg viewBox="0 0 40 40" aria-hidden="true">
                <circle class="track" cx="20" cy="20" r="15.5"></circle>
                <circle class="value" cx="20" cy="20" r="15.5" [style.strokeDasharray]="progressStrokeDasharray"></circle>
            </svg>
            <span aria-hidden="true">{{ completionPercent }}%</span>
        </button>

        <div class="fina-onboarding-navbar__copy">
            <div>
                <strong>{{ phase.title | uppercase }}</strong>
                <span>{{ phase.timeframe_label }}</span>
            </div>
            <h3>{{ heading }}</h3>
            <p>{{ completedTasks }} de {{ tasks.length }} tareas completadas</p>
        </div>

        <button type="button" class="fina-onboarding-navbar__detail" (click)="openDetail()">
            Ver detalle
            <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
        </button>
    </div>

    <div class="fina-onboarding-navbar__tasks" *ngIf="!isCompact">
        <article class="fina-onboarding-navbar__task" *ngFor="let task of visibleTasks" [class.completed]="task.isCompleted">
            <div class="fina-onboarding-navbar__task-icon">
                <fa-icon [icon]="['fas', task.isCompleted ? 'check' : 'file-lines']"></fa-icon>
            </div>

            <div class="fina-onboarding-navbar__task-copy">
                <div>
                    <h4>{{ task.title }}</h4>
                    <span *ngIf="task.is_mandatory">OBLIGATORIO</span>
                </div>
                <p>{{ task.description || 'Completa esta tarea para avanzar.' }}</p>
            </div>

            <span class="fina-onboarding-navbar__task-dismiss" aria-hidden="true">x</span>

            <button type="button" class="fina-onboarding-navbar__task-action" (click)="goToTask(task)">
                Ir
                <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
            </button>
        </article>
    </div>
</section>
